import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b33bdce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mySendCodeMessageBtn_wrap"
};
import { ref, computed } from 'vue';
import moment from 'moment';
export default {
  __name: 'mySendCodeMessageBtn',
  props: {
    delaySeconds: {
      type: Number,
      default: 60
    },
    getCode: {
      type: Function,
      required: true
    },
    uniqueKey: {
      type: Number,
      required: true
    },
    defaultText: {
      type: String,
      default: '获取验证码'
    }
  },
  setup(__props) {
    const myProps = __props;

    // 关键key
    const sign = `btn_${myProps.uniqueKey}_countdown`;
    // 本地是否已经存储计时信息
    const timeInfoStr = localStorage.getItem(sign);
    // 设置倒计时时间
    const count = ref(0);
    // 设置按钮禁用状态
    const disabled = ref(false);
    // 创建定时器函数
    const createTimer = () => {
      let timer = setInterval(() => {
        count.value = getDifferenceDate();
        if (myProps.delaySeconds - count.value >= myProps.delaySeconds) {
          localStorage.removeItem(sign);
          clearInterval(timer);
          disabled.value = false;
        }
      }, 1000);
    };
    // 获取当前时间与本地存储的时间差值
    const getDifferenceDate = () => {
      return myProps.delaySeconds - Math.floor((moment() - moment(JSON.parse(localStorage.getItem(sign)).currentTime)) / 1000);
    };
    // 如果存在本地存储的时间信息
    if (timeInfoStr) {
      disabled.value = true;
      count.value = getDifferenceDate();
      createTimer();
    } else {
      // 不存在本地存储的时间信息
      count.value = 0;
      disabled.value = false;
    }
    // 定义按钮字样
    let buttonText = computed(() => {
      if (disabled.value) {
        return `${count.value ? count.value : myProps.delaySeconds}s后重新获取`;
      } else {
        return myProps.defaultText;
      }
    });

    // 触发点击事件
    const handleClick = () => {
      // 获取当前时间
      const currentTime = new Date().getTime();
      // 新的计时信息
      const newTimeInfo = {
        delaySeconds: myProps.delaySeconds,
        sign,
        currentTime
      };
      // 存储计时信息
      localStorage.setItem(sign, JSON.stringify(newTimeInfo));
      if (!disabled.value) {
        disabled.value = true;
        // 调用父组件中传递过来的函数，也就是获取验证码的函数
        myProps.getCode();
        // 创建定时器函数
        createTimer();
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        type: "primary",
        disabled: disabled.value,
        onClick: handleClick
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(buttonText)), 1)]),
        _: 1
      }, 8, ["disabled"])]);
    };
  }
};